import { Box, Button, Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Markdown } from '../Markdown'
import imgUrl from './no-results.png'

export const EmptyState = ({
  headerMarkdown,
  helperText,
  resetFunction,
}: {
  children?: ReactNode
  headerMarkdown: string
  helperText: string
  resetFunction?: () => void
}) => {
  const { t } = useTranslation('@cibo/ui/emptyState')
  return (
    <Stack spacing={3} alignItems="center" py={3} data-testid="no-results">
      <Box
        sx={{
          backgroundImage: `url(${imgUrl})`,
          backgroundPositionX: 'center',
          height: 218,
          width: 218,
          borderRadius: '50%',
        }}
      />
      <Stack spacing={2} alignItems="center">
        <Markdown typographyProps={{ variant: 'h6' }}>{headerMarkdown}</Markdown>
        <Typography variant="body1" color="text.disabled">
          {helperText}
        </Typography>
        <Button onClick={resetFunction} variant="contained">
          {t('resetSearch')}
        </Button>
      </Stack>
    </Stack>
  )
}
